import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import React from "react"
import ReactToggle from "react-toggle"

/**
 * @typedef {object} ComponentsToggleButtonProps
 * @property {unknown} className
 */

/** @typedef {object} ComponentsToggleButtonState */

/**
 * @extends {ShapeComponent<ComponentsToggleButtonProps, ComponentsToggleButtonState>}
 */
class ComponentsToggleButton extends ShapeComponent {
  render() {
    const {className, ...restProps} = this.props

    return (
      <ReactToggle
        className={classNames("components--toggle-button", className)}
        icons={false}
        {...restProps}
      />
    )
  }
}

export default memo(shapeComponent(ComponentsToggleButton))
